const articleSubsection = () => {
  const subsection = new Component({
    component: document.getElementsByClassName('article_subsection'),
    callback: (component) => {
      const titleContent = component.getAttribute(`data-title`);

      const heading = new Element({
        type: `h3`,
        id: slugify(titleContent),
        classes: `heading--sm`,
        attributes: [
          [`data-anchor`, `subheading`]
        ],
        content: titleContent,
        append: {
          before: component.querySelector(`*:first-child`),
          parent: component
        }
      });
    }
  });
};

articleSubsection();